// extracted by mini-css-extract-plugin
export default {"controlGrid":"AddAnnouncement_controlGrid__UZLB2","icon":"AddAnnouncement_icon__WhVb3","labelText":"AddAnnouncement_labelText__pbXai"};